import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, throwFriendlyApiError } from '../common';

type Variables = {
  email: string;
  password: string;
  referralCode?: string;
  promoCode?: string;
};
export type AuthTokenResponse = {
  data: { token: string; setupComplete: boolean };
};

export const useCreateCustomer = createMutation<
  AuthTokenResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/signup',
      method: 'POST',
      data: {
        email: variables.email,
        password: variables.password,
        referral_code: variables.referralCode,
        promo_code: variables.promoCode,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'create account')),
});
